import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { CircularProgressRelevancy } from '../circular-progress-relevancy';
import * as Styled from './styles';
import * as SX from './sx';
import type { RelevancySummaryProps as Props } from './types';

export const RelevancySummary = memo(({ className, relevancy }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('RelevancySummary', className)}
      sx={SX.root}
    >
      <CircularProgressRelevancy relevancy={relevancy} />
    </Styled.Wrapper>
  );
});

RelevancySummary.displayName = 'RelevancySummary';
